import React, { useState } from "react";
import { Button } from "reactstrap";
import { acceptNotaryAppointment, declineNotaryAppointment } from "~/helpers/backendHelper";
import { showError } from "~/helpers/utilHelper";
import { formatTimestampTz, formats } from "~/helpers/dateHelper";
import { useAppointment } from "~/context/appointment";
import appointmentIcon from "~/assets/images/desktop/pending-img.svg";

const ViewAppointment = () => {

  const [isBusy, setIsBusy] = useState(false);

  const { order, refreshOrder, setIsDeclining } = useAppointment();

  const acceptMeeting = () => {
    setIsBusy(true);
    acceptNotaryAppointment().then(_res => {
      refreshOrder();
    }).catch(_err => {
      showError("Unable to accept the appointment");
    }).finally(() => {
      setIsBusy(false);
    });
  }

  const declineMeeting = () => {
    setIsBusy(true);
    declineNotaryAppointment().then(_res => {
      setIsDeclining(false);
      refreshOrder();
    }).catch(_err => {
      showError("Unable to decline the appointment")
    }).finally(() => {
      setIsBusy(false);
    });
  }

  return <React.Fragment>
    <div className="appointment-parent-box">
      <img className="apppointment-icon" src={appointmentIcon} />
      <div className="appointment-card-title mt-4 mb-2">Set an appointment</div>
      <div className="appointment-field mt-3">
        <label className="form-label label-text">Meeting address:</label>
        <input className="form-control" type="text" readOnly value={order?.orderNotary?.meetingAddress! || '--'} />
      </div>
      <div className="appointment-field mt-3">
        <label className="form-label">Meeting date:</label>
        <input className="form-control" type="text" readOnly value={order?.orderNotary?.meetingTs ? formatTimestampTz(order?.orderNotary?.meetingTs!, formats.APPOINTMENT_DATETIME, order?.orderNotary?.notaryTimezone!) : '--'} />
      </div>
      <div className="appointment-buttons d-flex justify-content-center">
        <Button color="primary" className="flex-fill me-2 opacity-btn" onClick={declineMeeting} disabled={isBusy}>Decline</Button>
        <Button color="primary" className="flex-fill ms-2" onClick={acceptMeeting} disabled={isBusy}>Accept</Button>
      </div>
    </div>
  </React.Fragment>
}

export default ViewAppointment;
